import { AbstractControl, ValidatorFn, Validators } from '@angular/forms';

export const noLocationOrIsSpare = (control: AbstractControl): boolean => {
  // Ensure this works for both form level errors and control level errors.
  const location = (control?.get('location') || control?.parent?.get('location'))?.value;
  return !location || location === 'SP';
};

/**
 * Ensure that comments and cost are filled if the tread is 3/32 or less.
 * Not applicable for spare tires.
 */
export const commentsAndCostRequiredByTreadValidator: ValidatorFn = control => {
  if (noLocationOrIsSpare(control)) {
    return null;
  }
  const tread = control?.get('tread');
  if (!tread || tread.value.length === 0) {
    return null;
  }
  const depthNumerator = Number(tread.value.split('/')[0]);
  if (Number.isNaN(depthNumerator)) {
    // This shouldn't happen, but handle it anyways
    return null;
  }

  if (depthNumerator > 3) {
    return null;
  }

  // This is pretty verbose, but Angular validators must return null if there are no errors
  const errors = {};
  const commentsRequired = !control.get('comments')?.value;
  if (commentsRequired) {
    errors['commentsRequired'] = true;
  }

  const costRequired = !control.get('damageCost')?.value;
  if (costRequired) {
    errors['costRequired'] = true;
  }

  return commentsRequired || costRequired ? errors : null;
};

/**
 * Ensure comments are populated if the cost is populated
 */
export const commentsRequiredIfCostValidator: ValidatorFn = control => {
  const damageCost = control.get('damageCost');
  if (!damageCost || !damageCost?.value) {
    return null;
  }
  const comments = control.get('comments');
  if (!comments || !comments?.value) {
    return {
      commentsRequired: true
    };
  }
  return null;
};

/**
 * Ensure the value is set and the value is included in a list
 */
export const isValidValue = (values: string[]): ValidatorFn => control => {
  if (noLocationOrIsSpare(control)) {
    return null;
  }
  const isInvalid = !control?.value || !values.includes(control.value);
  return isInvalid ? { invalidValue: true } : null;
};

export const isValidCost: ValidatorFn = control => {
  if ((!control || !control?.parent?.hasError('costRequired'))
    && !control?.value) {
    return null;
  }

  const cost = Number(control?.value);
  if (Number.isNaN(cost)) {
    return { invalid: true };
  }
  // Max length is 11 digits plus a period
  return cost.toFixed(2).length <= 12 ? null : { invalid: true };
};

export const requiredWhenNotSpare: ValidatorFn = control => {
  if (noLocationOrIsSpare(control)) {
    return null;
  }
  return Validators.required(control);
};
